<!--
 * @Author: M.D.
 * @Date: 2020-01-05 16:04:45
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="order-o-w">
    <order-progressbar
      ref="odProgress"
      @orderDetailUpdate="orderUpdate"
      :orderProp="orderInfo" />   
      <!-- orderInfo订单信息  orderUpdate初始化订单信息 -->
    <div class="od-table" @click="prdDetail(orderInfo)">
      <div class="od-t-name">
        <div class="n-h">商品名称</div>
        <div class="n-ct">
          <div class="od-t-n-l">
            <div  v-show="!showVideo" class="od-t-img-w">
              <img :src="tImgUrl((orderInfo.image && orderInfo.image.split(',')[0]) || '')" alt="" :onerror="errImgDefault">
            </div>
            <div class="od-t-video-w" @click="broadcast($event)">
              <video-player v-show="showVideo" style="width: 160px;height: 90px"
                            ref="videoPlayer"
                            :playsinline="true"
                            :options="playerOptions">
              </video-player>
            </div>
          </div>
          <div class="od-t-n-r">
            <div class="od-t-title">
              {{orderInfo.goodsName}}
            </div>
            <div class="od-t-sub-title">
              {{ orderInfo.intro||''}}
            </div>
          </div>
        </div>
      </div>
      <div class="od-t-price">
        <div class="pr-h">单价</div>
        <div class="pr-ct">{{ priceDis(orderInfo, 'price') }}</div>
      </div>
      <div class="od-t-count">
        <div class="c-h">数量</div>
        <div class="c-ct">{{orderInfo.number}}</div>
      </div>
      <div class="od-t-point">
        <div class="p-h">所获积分</div>
        <div class="p-ct"> {{ orderInfo.gainPoint }}</div>
      </div>
      <div class="od-t-total">
        <div class="t-h">小计</div>
        <div class="t-ct">{{ priceDis(orderInfo) }}</div>
      </div>
    </div>
    <div class="od-info">
      <div class="od-info-l">
        <div>订单编号：{{ orderInfo.orderNumber }}</div>
        <div>支付方式：{{ orderInfo.isOnLinePay === 0 ? '线上支付' : '线下支付' }}</div>
        <div>订单时间：{{ orderInfo.createTime }}</div>
        <div v-if="orderInfo.discountAmount">商品折扣：￥{{ orderInfo.discountAmount }}</div>
        <div :key="info.key" v-for="info in invoiceInfos">{{ `${info.key || ''}：${info.value || ''}` }}</div>
        <!-- <div>发票抬头：{{ invoiceRise }}</div>
        <div>电子邮箱：{{ orderInfo.mailbox }}</div> -->
      </div>
      <div class="od-info-r">
        <div>总计金额：{{ priceDis(orderInfo) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/api'
import { mapGetters } from 'vuex'
import OrderProgressbar from '@/components/order-progressbar'
// import func from '../../../vue-temp/vue-editor-bridge'
export default {
  props: {

  },
  data () {
    return {
      showVideo: false,
      // goodsInfo: {},
      orderInfo: { isOnlinePay: 0, type: 0 },
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'false', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: '', // 路径
          type: 'video/mp4' // 类型
        }],
        width: document.documentElement.clientWidth,
        poster: '', // 你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    invoiceInfos () {
      if (!this.orderInfo) {
        return []
      }
      const invoiceStatus = ['已开发票', '未开发票', '发票开具中']
      const dictionary = {
        'invoiceRise': '发票抬头',
        'mailbox': '收票人邮箱',
        'enterpriseName': this.orderInfo.invoiceRiseType === 1 ? '企业名称' : '单位名称',
        'taxpayerNumber': '纳税人识别号',
        'bank': '开户银行',
        'bankNumber': '银行账号',
        'enterpriseAddress': '企业地址',
        'enterpriseMobile': '企业电话',
        'invoiceContent': '发票内容'
      }
      const configs = [
        ['invoiceRise', 'mailbox'],
        ['enterpriseName', 'taxpayerNumber', 'mailbox'],
        ['enterpriseName', 'taxpayerNumber', 'mailbox']
      ]
      const config1 = ['invoiceRise', 'taxpayerNumber', 'bank', 'bankNumber', 'enterpriseAddress', 'enterpriseMobile']
      const invoiceTypes = ['电子普通发票', '增值税专票']
      const invoiceRiseTypes = ['个人', '企业', '事业单位']

      let invoiceInfos = []
      invoiceInfos.push({ key: '发票信息', value: invoiceStatus[this.orderInfo.isApplyInvoice] })
      console.log("发票信息",invoiceInfos)
      if (this.orderInfo.isApplyInvoice === 1) {
        return invoiceInfos
      }
      invoiceInfos.push({ key: '发票类型', value: invoiceTypes[this.orderInfo.invoiceType - 1] })
      // invoiceType: 1电子普通发票，2增值税专票
      if (this.orderInfo.invoiceType === 1) {
        // invoiceRiseType: 0个人 1企业 2事业单位
        invoiceInfos.push({ key: '抬头类型', value: invoiceRiseTypes[this.orderInfo.invoiceRiseType || 0] })

        // invoiceRiseType=0:invoiceRise,mailbox
        // invoiceRiseType=1:enterpriseName,taxpayerNumber,mailbox
        // invoiceRiseType=2:enterpriseName,taxpayerNumber,mailbox
        let keys = configs[this.orderInfo.invoiceRiseType || 0]
        for (const key of keys) {
          invoiceInfos.push({
            key: dictionary[key],
            value: this.orderInfo[key]
          })
        }
      } else {
        // // invoiceType: 2增值税专票
        // invoiceRise,taxpayerNumber,bank,bankNumber,enterpriseAddress,enterpriseMobile
        for (const key of config1) {
          invoiceInfos.push({
            key: dictionary[key],
            value: this.orderInfo[key]
          })
        }
      }
      console.log(invoiceInfos)
      return invoiceInfos
    }
  },
  created () {
  },
  mounted () {

  },
  activated () {
    this.initData()
  },
  deactivated () {

  },
  watch: {
  },
  methods: {
    broadcast (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    async prdDetail (i) {
      const re = await API.getPrdDetail(i.goodsId)
      if (re.data.statusCode === '302') {
        this.$alert(`商品已下架`, '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          center: true
        })
        return
      }
      this.$router.push({ name: 'productDetail', params: { prodId: i.goodsId } })
    },
    async initData () {
      const orRe = await API.getOrderDetail({ orderId: this.$route.params.orderId })
      this.orderInfo = orRe.data.result
      this.orderInfo.isOnTrain = this.$route.params.isOnTrain
      this.showVideo = true
      if (this.orderInfo.videoUrl) {
        this.playerOptions.sources[0].src = process.env.VUE_APP_BASE_API + 'video/getVideo?goodsId=' +
            this.orderInfo.goodsId + '&orderNumber=' + this.orderInfo.orderNumber + '&token=' + this.userInfo.token
        // console.log(this.playerOptions.sources[0].src)
        this.playerOptions.poster = this.tImgUrl(this.orderInfo.image)
      } else {
        this.showVideo = false
      }
      // const gdsRe = await API.getPrdDetail(this.orderInfo.goodsId)
      // this.goodsInfo = gdsRe.data.result
      // if (this.goodsInfo.videoUrl) {
      //   this.showVideo = true
      //   this.playerOptions.sources[0].src = process.env.VUE_APP_BASE_API + 'video/getVideo?goodsId=' +
      //     this.orderInfo.goodsId + '&orderNumber=' + this.orderInfo.orderNumber + '&token=' + this.userInfo.token
      //   console.log(this.playerOptions.sources[0].src)
      //   this.playerOptions.poster = this.tImgUrl(this.goodsInfo.image)
      // } else {
      //   this.showVideo = false
      // }
    },
    orderUpdate () {
      console.log('orderUpdate')
      this.initData()
    }
  },
  components: {
    OrderProgressbar
  }
}
</script>

<style lang="stylus">
.order-o-w
  .od-progressbar
    width 100%
    height 400px
  .od-table
    color #777777
    display flex
    [class$="-h"]
      height 40px
      center()
    [class$="-ct"]
      height 130px
      background-color #ffffff
      center()
      border-right 2px solid #f1f1f1
      border-bottom 2px solid #f1f1f1
      padding 20px 0
      box-sizing border-box
    .od-t-name
      flex 4 4 auto
      .n-ct
        display flex
        padding 20px 30px
        >div
          height auto
          max-height 100px
        .od-t-n-l
          flex 0 0 160px
          background-color green
          overflow hidden
          margin-right 20px
          .od-t-img-w
            goods-img-wrapper()
            img
              goods-img-image()
          .od-t-video-w
            display: inline-block;
            width: 160px;
            height: 90px;
            text-align: center;
            line-height: 90px;
            .vjs-big-play-button
              margin-left 25px
              margin-top 10px
        .od-t-n-r
          flex 1 1 auto
          .od-t-title
            max-width 500px
            font-size 20px
            line-height 26px
            color #333333
            margin 6px 0px 20px
    .od-t-price
      flex 1.5 1.5 auto
    .od-t-count
      flex 1 1 auto
    .od-t-point
      flex 1 1 auto
    .od-t-total
      flex 1 1 auto
  .od-info
    display flex
    >div
      min-height 200px
      background-color #ffffff
      padding 40px
      box-sizing border-box
    .od-info-l
      flex 1 1 auto
      color #999999
      >div
        // height 36px
        line-height 36px
    .od-info-r
      flex 0 0 400px
      flex-right()
      color orange-color
      font-size 20px
      font-weight bold

</style>
